import VariantSelector from '../../form-elements/VariantSelector';
import { useStoreIdSafe } from '../../context';
import type { WidgetProps } from '@rjsf/utils';

function VariantSelectorWidget(props: WidgetProps) {
  const storeIdContext = useStoreIdSafe();
  const storeId = storeIdContext?.storeId || (props.options?.storeId as string);

  return <VariantSelector value={props.value} onChange={props.onChange} storeId={storeId} />;
}

export default VariantSelectorWidget;
